import React from 'react';

interface Props {
  open: boolean;
  jobRef: string;
  showPosInline: boolean;
  onShowPosInline: (v: boolean) => void;
  onClose: () => void;
}

export const InventorySettingsDrawer: React.FC<Props> = ({
  open, jobRef, showPosInline, onShowPosInline, onClose,
}) => {
  if (!open) return null;

  return (
    <div className="tm-drawer-backdrop" onClick={onClose}>
      <div className="tm-drawer" onClick={e => e.stopPropagation()}>
        <div className="tm-drawer-head">
          <div>
            <div className="crumb">Job <span>{jobRef}</span> · Inventory</div>
            <h2>Inventory settings</h2>
          </div>
          <button type="button" className="tm-drawer-x" onClick={onClose}>✕</button>
        </div>
        <div className="tm-drawer-body">
          <div className="tm-set-new">
            <span className="new-badge">NEW</span>
            <label className="chk-line">
              <input
                type="checkbox"
                checked={showPosInline}
                onChange={e => onShowPosInline(e.target.checked)}
              />
              <span>Show purchase orders <b>inline</b> on billable items</span>
            </label>
          </div>
          <p style={{ color: 'var(--tm-muted)', fontWeight: 600, fontSize: 12.5, lineHeight: 1.45 }}>
            When enabled, PO lines appear in the billable items table with live reconciliation
            state from linked bills — same as the prototype job workspace.
          </p>
        </div>
      </div>
    </div>
  );
};
